/* Avora market localization — converts base-store EUR copy with Shopify Markets' active rate. */
(function (root, factory) {
  'use strict';

  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.AvoraMarketLocalization = api;
    api.start(root);
  }
})(typeof self !== 'undefined' ? self : this, function (root) {
  'use strict';

  var storeMoneyFormat = '';
  var storeBaseCurrency = '';

  function positiveNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function browserCountry(languages, availableCountries) {
    var available = (availableCountries || []).map(function (code) { return String(code || '').toUpperCase(); });
    var candidates = Array.isArray(languages) ? languages : [];
    for (var i = 0; i < candidates.length; i += 1) {
      var parts = String(candidates[i] || '').replace(/_/g, '-').split('-');
      for (var j = parts.length - 1; j >= 1; j -= 1) {
        var code = parts[j].toUpperCase();
        if (code.length === 2 && (!available.length || available.indexOf(code) !== -1)) return code;
      }
    }
    return '';
  }

  function context(environment) {
    var env = environment || {};
    var configured = env.__avoraMarketContext || {};
    var shopifyCurrency = env.Shopify && env.Shopify.currency ? env.Shopify.currency : {};
    var baseCurrency = String(configured.baseCurrency || 'EUR').toUpperCase();
    var currency = String(shopifyCurrency.active || configured.currency || baseCurrency).toUpperCase();
    var rate = currency === baseCurrency ? 1 : positiveNumber(shopifyCurrency.rate || configured.rate);
    var navigatorObject = env.navigator || {};
    var languages = navigatorObject.languages || (navigatorObject.language ? [navigatorObject.language] : []);
    var locale = String(configured.locale || languages[0] || 'en');

    return {
      baseCurrency: baseCurrency,
      currency: currency,
      rate: rate,
      ready: currency === baseCurrency || rate > 0,
      country: String(configured.country || '').toUpperCase(),
      browserCountry: browserCountry(languages, configured.availableCountries),
      locale: locale
    };
  }

  // Same hundredths contract and zero-decimal currencies as wallet-shared.js.
  // Shopify: help.shopify.com/en/manual/international/pricing/currency-formatting
  var zeroDecimalCurrencies = 'BIF CLP DJF GNF ISK JPY KMF KRW PYG RWF UGX VND VUV XAF XOF XPF'.split(' ');
  function convertMinor(baseMinor, rate, currency, intent) {
    var amount = Number(baseMinor);
    var rateMatch = /^(\d+)(?:\.(\d+))?$/.exec(String(rate == null ? '' : rate));
    if (!Number.isSafeInteger(amount) || amount < 0 || !rateMatch) return null;
    var fractional = rateMatch[2] || '';
    var denominator = 10n ** BigInt(fractional.length);
    var numerator = BigInt(rateMatch[1]) * denominator + BigInt(fractional || '0');
    if (numerator <= 0n) return null;
    var quantum = zeroDecimalCurrencies.indexOf(String(currency || '').toUpperCase()) === -1 ? 1n : 100n;
    var scaled = BigInt(amount) * numerator;
    var converted;
    if (quantum > 1n && intent === 'minimum') {
      var divisor = denominator * quantum;
      converted = ((scaled + divisor - 1n) / divisor) * quantum;
    } else {
      var cents = (scaled + denominator / 2n) / denominator;
      converted = ((cents + quantum / 2n) / quantum) * quantum;
    }
    return converted > BigInt(Number.MAX_SAFE_INTEGER) ? null : Number(converted);
  }

  function formatMinor(minor, currency, locale, compact) {
    var amount = Number(minor);
    if (!Number.isFinite(amount)) return '';
    // Match Liquid's configured separators for the store currency. Keep Intl for
    // other Markets currencies so a EUR template can never label USD as euros.
    var tokenMatch = storeMoneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (currency === storeBaseCurrency && tokenMatch) {
      var token = tokenMatch[1];
      var precision = token.indexOf('no_decimals') !== -1 || (compact !== false && amount % 100 === 0) ? 0 : 2;
      var thousands = token.indexOf('comma_separator') !== -1 ? '.' : ',';
      var decimal = token.indexOf('comma_separator') !== -1 ? ',' : '.';
      if (token.indexOf('space_separator') !== -1) thousands = ' ';
      if (token.indexOf('apostrophe_separator') !== -1) thousands = "'";
      var parts = (amount / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return storeMoneyFormat.replace(tokenMatch[0], parts.join(decimal)).replace(/<[^>]*>/g, '');
    }
    try {
      var baseFormatter = new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: currency || 'EUR' });
      var fractionDigits = baseFormatter.resolvedOptions().maximumFractionDigits;
      return new Intl.NumberFormat(locale || 'en', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: compact === false || amount % 100 ? fractionDigits : 0,
        maximumFractionDigits: fractionDigits
      }).format(amount / 100);
    } catch (error) {
      return String(currency || 'EUR') + ' ' + (amount / 100).toFixed(amount % 100 ? 2 : 0);
    }
  }

  // Fixed commercial promises only. Never use this map for product prices,
  // cart balances, tax, top-ups or other transactional amounts.
  var fixedGbpCopy = {499:500,6000:6000,2000:2000,4000:4000,7000:7000,11000:11000,17500:17500,9000:9000,15000:15000,25000:25000,35000:35000,50000:50000,2500:2500,3500:3500,5000:5000,10000:10000};
  // Generated from avora-reward-config.json usOffers; parity checked in QA.
  var usOffers = {"version":"2026-09-15.2","country":"US","currency":"USD","amounts":{"499":600,"6000":6000,"9000":10000,"15000":20000,"25000":30000,"35000":50000,"50000":75000,"2000":2500,"4000":5000,"7000":8500,"11000":15000,"17500":20000,"2500":3000,"3500":5000,"5000":7500,"10000":12500}};
  function offerMinor(baseMinor, marketContext, intent) {
    var ctx = marketContext || {};
    if (ctx.country === usOffers.country && ctx.currency === usOffers.currency && ctx.baseCurrency === 'EUR' && Object.prototype.hasOwnProperty.call(usOffers.amounts, baseMinor)) return usOffers.amounts[baseMinor];
    if (ctx.currency === 'GBP' && ctx.baseCurrency === 'EUR' && Object.prototype.hasOwnProperty.call(fixedGbpCopy, baseMinor)) return fixedGbpCopy[baseMinor];
    return convertMinor(baseMinor, ctx.rate, ctx.currency, intent);
  }

  function formatBaseMinor(baseMinor, marketContext, intent) {
    var ctx = marketContext || {};
    var converted = offerMinor(baseMinor, ctx, intent);
    return converted == null ? '' : formatMinor(converted, ctx.currency, ctx.locale);
  }

  function localizeTier(tier, marketContext) {
    var source = tier || {};
    var localized = Object.assign({}, source);
    ['threshold', 'wallet', 'futureCard', 'futureMinimum'].forEach(function (key) {
      var baseKey = 'base' + key.charAt(0).toUpperCase() + key.slice(1);
      localized[baseKey] = Number(source[key]) || 0;
      localized[key] = offerMinor(source[key], marketContext,
        key === 'threshold' || key === 'futureMinimum' ? 'minimum' : 'nearest') || 0;
    });
    var translate = root && root.AvoraI18n ? root.AvoraI18n.text : function (text, values) {
      return text.replace(/\{(\w+)\}/g, function (_, key) { return values[key]; });
    };
    var amounts = {
      wallet: formatMinor(localized.wallet, marketContext.currency, marketContext.locale),
      card: formatMinor(localized.futureCard, marketContext.currency, marketContext.locale),
      minimum: formatMinor(localized.futureMinimum, marketContext.currency, marketContext.locale)
    };
    localized.title = translate(localized.futureCard ? '{wallet} Gift Wallet + {card} Reward Card' : '{wallet} Gift Wallet', amounts);
    if (typeof source.detail === 'string') localized.detail = translate(localized.futureCard
      ? '{card} off a future {minimum}+ order'
      : 'Choose {wallet} in gifts', amounts);
    return localized;
  }

  function localizeConfig(sharedConfig, marketContext) {
    if (!sharedConfig || !marketContext || !marketContext.ready) return null;
    if (String(sharedConfig.currencyCode || '').toUpperCase() !== String(marketContext.baseCurrency || '').toUpperCase()) return null;
    return Object.assign({}, sharedConfig, {
      version: marketContext.country === 'US' && marketContext.currency === 'USD' && sharedConfig.usOffers ? sharedConfig.usOffers.version : marketContext.currency === 'GBP' && sharedConfig.fixedGbpOffers === true ? sharedConfig.gbpConfigVersion : sharedConfig.version,
      currency: marketContext.currency,
      currencyRate: marketContext.rate,
      marketCountry: marketContext.country,
      locale: marketContext.locale,
      tiers: (sharedConfig.tiers || []).map(function (tier) { return localizeTier(tier, marketContext); })
    });
  }

  function euroAmountToMinor(value) {
    var compact = String(value || '').replace(/[\s\u00a0\u202f]/g, '');
    var decimal = /[.,](\d{1,2})$/.exec(compact);
    var whole = Number((decimal ? compact.slice(0, decimal.index) : compact).replace(/[.,]/g, '')) || 0;
    var fractional = String(decimal ? decimal[1] : '').padEnd(2, '0');
    return whole * 100 + (Number(fractional) || 0);
  }

  function replaceEuroAmounts(text, replace) {
    // French and other translations naturally move € after the amount. Support
    // both positions, decimal conventions and nonbreaking thousands separators.
    return text.replace(/€\s?([0-9]+(?:[.,\u00a0\u202f ]\d{3})*(?:[.,]\d{1,2})?)|([0-9]+(?:[.,\u00a0\u202f ]\d{3})*(?:[.,]\d{1,2})?)\s?€/g, function (match, before, after) {
      return replace(match, before || after);
    });
  }

  function replaceBaseMoney(text, marketContext, minimumAmounts) {
    if (!marketContext || !marketContext.ready || typeof text !== 'string' || text.indexOf('€') === -1) return text;
    return replaceEuroAmounts(text, function (_match, amount) {
      var baseMinor = euroAmountToMinor(amount);
      var intent = (minimumAmounts || []).indexOf(baseMinor) === -1 ? 'nearest' : 'minimum';
      return formatBaseMinor(baseMinor, marketContext, intent);
    });
  }

  function localizeCopy(root, marketContext) {
    if (!root || !marketContext || !marketContext.ready) return;
    // Reward-page markup already declares each amount's role. Derive its
    // minimums before translating so headings, prose and ARIA copy agree with
    // the numeric tier rules without another hardcoded reward ladder.
    var minimumAmounts = [];
    if (root.querySelectorAll) root.querySelectorAll('[data-threshold], [data-minimum]').forEach(function (element) {
      ['data-threshold', 'data-minimum'].forEach(function (name) {
        replaceEuroAmounts(String(element.getAttribute(name) || ''), function (_match, amount) {
          var minor = euroAmountToMinor(amount);
          if (minimumAmounts.indexOf(minor) === -1) minimumAmounts.push(minor);
          return _match;
        });
      });
    });
    var doc = root.ownerDocument || root;
    var walker = doc.createTreeWalker(root, 4);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && !node.parentElement.closest('script, style, template')) {
        var localizedText = replaceBaseMoney(node.nodeValue, marketContext, minimumAmounts);
        if (node.nodeValue !== localizedText) node.nodeValue = localizedText;
      }
    }
    if (root.attributes) {
      Array.prototype.forEach.call(root.attributes, function (attribute) {
        if (attribute.value.indexOf('€') !== -1) root.setAttribute(attribute.name, replaceBaseMoney(attribute.value, marketContext, minimumAmounts));
      });
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('*').forEach(function (element) {
        Array.prototype.forEach.call(element.attributes || [], function (attribute) {
          if (attribute.value.indexOf('€') !== -1) element.setAttribute(attribute.name, replaceBaseMoney(attribute.value, marketContext, minimumAmounts));
        });
      });
    }
  }

  function renderDocument(doc, marketContext) {
    if (!doc || !marketContext.ready) return;
    doc.querySelectorAll('[data-avora-market-money]').forEach(function (element) {
      var formatted = formatBaseMinor(element.getAttribute('data-base-minor'), marketContext);
      if (formatted && element.textContent !== formatted) element.textContent = formatted;
    });
    doc.querySelectorAll('[data-avora-localize-euro-copy], .avora-cart-delivery__message').forEach(function (element) {
      localizeCopy(element, marketContext);
    });
  }

  function start(environment) {
    var env = environment || {};
    if (!env.document) return;
    var marketContext = context(env);
    storeMoneyFormat = typeof env.__shopMoneyFormat === 'string' ? env.__shopMoneyFormat : '';
    storeBaseCurrency = marketContext.baseCurrency;
    env.__avoraResolvedMarket = marketContext;

    function render() {
      renderDocument(env.document, marketContext);
      env.document.dispatchEvent(new CustomEvent('avora:market-ready', { detail: marketContext }));
    }

    if (env.document.readyState === 'loading') env.document.addEventListener('DOMContentLoaded', render, { once: true });
    else render();
    env.document.addEventListener('shopify:section:load', render);
    // Cart section replacements reintroduce server-rendered delivery copy.
    // Observe only marked copy; idempotent writes stop feedback after localization.
    if (env.MutationObserver) {
      var copySelector = '[data-avora-market-money], [data-avora-localize-euro-copy], .avora-cart-delivery__message';
      new env.MutationObserver(function (records) {
        var insertedCopy = records.some(function (record) {
          if (record.type === 'characterData' && record.target.parentElement && record.target.parentElement.closest(copySelector)) return true;
          return Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 ? (node.matches(copySelector) || node.querySelector(copySelector))
              : node.nodeType === 3 && node.parentElement && node.parentElement.closest(copySelector);
          });
        });
        if (insertedCopy) renderDocument(env.document, marketContext);
      }).observe(env.document.documentElement, { childList: true, characterData: true, subtree: true });
    }

  }

  return {
    browserCountry: browserCountry,
    context: context,
    convertMinor: convertMinor,
    offerMinor: offerMinor,
    formatMinor: formatMinor,
    formatBaseMinor: formatBaseMinor,
    localizeTier: localizeTier,
    localizeConfig: localizeConfig,
    replaceBaseMoney: replaceBaseMoney,
    localizeCopy: localizeCopy,
    renderDocument: renderDocument,
    start: start
  };
});
